export default {
    methods: {
        productUrl({ product, variant }) {
            console.log('products of cart', product);
            console.log('variant.uid', variant?.uid);
            return route("products.show", {
                slug: product.slug,
                ...(variant && variant.uid ? { variant: variant.uid } : {}),
                // ...(variant !== null && {
                //     variant: variant.uid,
                // }),
            });
        },

        productSellUrl({ product, variant }) {
            // console.log('products', product);
            return route("products.show", {
                slug: product.slug
            });
        },

        productPreorderUrl({ product, variant }) {
            console.log('products', product);
            console.log('variant.uid', variant?.uid);
            return route("products.show", {
                slug: product.slug,
                ...(variant && variant.uid ? { variant: variant.uid } : {}),
            });
        },

        hasBaseImage({ item }) {
            return item.base_image.length !== 0;
        },

        baseImage(cartItem) {
            return cartItem.product.base_image.path;
            if (this.hasBaseImage(cartItem)) {
                return cartItem.product.base_image.path;
            }

            return `${window.FleetCart.baseUrl}/build/assets/image-placeholder.png`;
        },

        optionValues(option) {
            let values = [];

            for (let value of option.values) {
                values.push(value.label);
            }

            return values.join(", ");
        },

        maxQuantity({ item }) {
            return item.is_in_stock && item.does_manage_stock ? item.qty : null;
        },

        exceedsMaxStock({ item, qty }) {
            return item.does_manage_stock && item.qty < qty;
        },

        isQtyIncreaseDisabled(cartItem) {
            return (
                this.maxQuantity(cartItem) !== null &&
                cartItem.qty >= cartItem.item.qty
            );
        },

        changeQuantity(cartItem, qty) {
            if (isNaN(qty) || qty < 1) {
                qty = 1;

                this.updateCart(cartItem, qty);

                return;
            }

            cartItem.qty = qty;

            if (this.exceedsMaxStock(cartItem)) {
                qty = cartItem.item.qty;

                this.updateCart(cartItem, qty);

                return;
            }

            this.updateCart(cartItem, qty);
        },

        updateQuantity(cartItem, qty) {
            if (isNaN(qty) || qty < 1) {
                qty = 1;
                cartItem.qty = 1;

                return;
            }

            cartItem.qty = qty;

            if (this.exceedsMaxStock(cartItem)) {
                cartItem.qty = cartItem.item.qty;

                this.updateCart(cartItem, cartItem.qty);

                return;
            }

            this.updateCart(cartItem, qty);
        },
        changeSellQuantity(cartItem, qty) {
            if (isNaN(qty) || qty < 1) {
                qty = 1;
                this.updateSellCart(cartItem, qty);
                return;
            }
            cartItem.qty = qty;
            this.updateSellCart(cartItem, qty);
        },

        updateSellQuantity(cartItem, qty) {
            if (isNaN(qty) || qty < 1) {
                qty = 1;
                cartItem.qty = 1;
                return;
            }

            cartItem.qty = qty;
            this.updateSellCart(cartItem, qty);
        },

        changePreorderQuantity(cartItem, qty) {
            if (isNaN(qty) || qty < 1) {
                qty = 1;
                this.updatePreorderCart(cartItem, qty);
                return;
            }
            cartItem.qty = qty;
            this.updatePreorderCart(cartItem, qty);
        },

        updatePreorderQuantity(cartItem, qty) {
            if (isNaN(qty) || qty < 1) {
                qty = 1;
                cartItem.qty = 1;
                return;
            }

            cartItem.qty = qty;
            this.updatePreorderCart(cartItem, qty);
        },
    },
};
